import AES from 'crypto-js/aes';
import CryptoJSCore from 'crypto-js/core';
import { useTranslation } from 'react-i18next';
import { ScatterBoard } from "../components/react-scatter-board/ScatterBoard";


function decrypt(base, key, iv) {
    key = CryptoJSCore.enc.Utf8.parse(key);
    iv = CryptoJSCore.enc.Utf8.parse(iv);

    var decrypted = AES.decrypt(base, key, { iv: iv, mode: CryptoJSCore.mode.CBC });

    return decrypted.toString(CryptoJSCore.enc.Utf8);

}

function delete_cookie(name, path, domain) {
    if (get_cookie(name)) {
        document.cookie = name + "=" +
            ((path) ? ";path=" + path : "") +
            ((domain) ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}
function get_cookie(name) {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
}

let iv = "";

const Visualization = () => {
    const { t } = useTranslation();
    var d = JSON.parse(document.getElementById(window.atob('X191c2VyX2ZpbmdlcnByaW50')).innerText);
    var k = JSON.parse(document.getElementById(window.atob('X191c2VyX2lk')).innerText);

    var n = '__session_id';
    if (!iv) {
        iv = document.cookie
            .split('; ')
            .find(row => row.startsWith(n + "="))
            .split('=')[1];
        delete_cookie(n, '/', window.location.hostname);
    }

    var data = JSON.parse(decrypt(d, k, iv));

    const width = window.innerWidth > 800 ? 800 : window.innerWidth;
    const height = window.innerWidth > 800 ? 500 : 400;

    return <>
        <div className="container visualization-container" style={{ "minHeight": "500px" }}>
            <h1>{t("Explore the Dental Implant Galaxy")}</h1>
            <ScatterBoard
                data={data}
                shapeKey='shape'
                colorKey='Level'
                labelKeys={['label']}
                style={{ "margin": "0 auto" }}
                is3d={true}
                width={width}
                height={height}
            />

        </div>
    </>;
};


export default Visualization;